/* eslint-disable no-return-assign */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function ViewSOA({ data, showTransaction, id, approvingSOA, approveSOA }) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
    showTransaction(id);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${c.OVR_URI.replace(
    '{id}',
    _.get(data, 'id')
  )}?bearer_token=${token}&email=${_.get(
    authProfile,
    'email'
  )}&soa_remarks=${_.get(data, 'soa_remarks')}`;

  const handleApprove = e => {
    e.preventDefault();

    approveSOA(id, {}, () => {
      setModal({ isOpen: false });
      showTransaction(id);
    });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Statement of Account"
                  src={src}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {Acl(permissions, ['OVRS APPROVE SOA']) &&
          _.get(data, 'attributes.transaction_status') === 'COMPUTED' ? (
            <button
              type="button"
              onClick={handleApprove}
              className="btn gen-btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
              disabled={approvingSOA}
            >
              Approve
            </button>
          ) : (
            ''
          )}
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewSOA.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  approvingSOA: PropTypes.bool.isRequired,
  approveSOA: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  approvingSOA: api.loading.indexOf(c.APPROVE_SOA) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewSOA);
